import { render } from "./BGZG27.vue?vue&type=template&id=9dbe6800&scoped=true"
import script from "./BGZG27.vue?vue&type=script&lang=js"
export * from "./BGZG27.vue?vue&type=script&lang=js"

import "./BGZG27.vue?vue&type=style&index=0&id=9dbe6800&lang=css"
import "./BGZG27.vue?vue&type=style&index=1&id=9dbe6800&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dbe6800"]])

export default __exports__